import React from "react";
import "./CustomGoBack.scss";

export default function CustomGoBack({ onGoBack }) {
  return (
    <div className="goBackSection" onClick={onGoBack}>
      <span className="goBackIcon">
        <i className="ri-arrow-left-line"></i>
      </span>
      <span className="goBackText">Go back</span>
    </div>
  );
}
